if (!customElements.get('gs-branches-locator')) {
  const GS_BRANCHES_LEAFLET_JS_URL = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
  const GS_BRANCHES_LEAFLET_CSS_URL = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
  const GS_BRANCHES_MARKER_SVG =
    '<svg width="28" height="40" viewBox="0 0 28 40" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M14 0C6.268 0 0 6.268 0 14c0 10.5 14 26 14 26s14-15.5 14-26C28 6.268 21.732 0 14 0z" fill="#2f7a4d"/>' +
    '<circle cx="14" cy="14" r="5" fill="#ffffff"/>' +
    '</svg>';

  let gsBranchesLeafletLoadPromise = null;
  let gsBranchesMarkerIcon = null;

  function gsBranchesLoadLeaflet() {
    if (window.L) {
      return Promise.resolve(window.L);
    }

    if (gsBranchesLeafletLoadPromise) {
      return gsBranchesLeafletLoadPromise;
    }

    gsBranchesLeafletLoadPromise = new Promise((resolve, reject) => {
      if (!document.querySelector('link[data-gs-branches-leaflet-css]')) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = GS_BRANCHES_LEAFLET_CSS_URL;
        link.setAttribute('data-gs-branches-leaflet-css', '');
        document.head.appendChild(link);
      }

      const existingScript = document.querySelector('script[data-gs-branches-leaflet-js]');

      if (existingScript) {
        existingScript.addEventListener('load', () => resolve(window.L));
        existingScript.addEventListener('error', reject);
        return;
      }

      const script = document.createElement('script');
      script.src = GS_BRANCHES_LEAFLET_JS_URL;
      script.setAttribute('data-gs-branches-leaflet-js', '');
      script.addEventListener('load', () => resolve(window.L));
      script.addEventListener('error', reject);
      document.head.appendChild(script);
    });

    return gsBranchesLeafletLoadPromise;
  }

  function gsBranchesGetMarkerIcon(L) {
    if (!gsBranchesMarkerIcon) {
      gsBranchesMarkerIcon = L.divIcon({
        className: 'gs-branches-map-marker',
        html: GS_BRANCHES_MARKER_SVG,
        iconSize: [28, 40],
        iconAnchor: [14, 40],
      });
    }

    return gsBranchesMarkerIcon;
  }

  function gsBranchesInitMap(container) {
    if (container.dataset.branchesMapInitialized) {
      return;
    }

    container.dataset.branchesMapInitialized = 'true';

    const lat = parseFloat(container.dataset.lat);
    const lng = parseFloat(container.dataset.lng);

    if (Number.isNaN(lat) || Number.isNaN(lng)) {
      return;
    }

    gsBranchesLoadLeaflet().then((L) => {
      const map = L.map(container, { scrollWheelZoom: false }).setView([lat, lng], 15);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a>',
      }).addTo(map);

      map.attributionControl.setPrefix(false);

      L.marker([lat, lng], { icon: gsBranchesGetMarkerIcon(L), alt: container.getAttribute('aria-label') || '' }).addTo(
        map
      );
    });
  }

  class GsBranchesLocator extends HTMLElement {
    connectedCallback() {
      this.governorateSelect = this.querySelector('[data-branches-governorate]');
      this.citySelect = this.querySelector('[data-branches-city]');
      this.cards = Array.from(this.querySelectorAll('[data-branches-card]'));
      this.countEl = this.querySelector('[data-branches-count]');
      this.emptyState = this.querySelector('[data-branches-empty]');
      this.mapContainers = Array.from(this.querySelectorAll('[data-branches-map]'));

      const cityMapEl = this.querySelector('[data-branches-city-map]');
      this.cityMap = cityMapEl ? JSON.parse(cityMapEl.textContent) : {};
      this.allCitiesLabel = this.citySelect ? this.citySelect.dataset.allCitiesLabel || '' : '';

      if (this.governorateSelect) {
        this.governorateSelect.addEventListener('change', () => this.handleGovernorateChange());
      }

      if (this.citySelect) {
        this.citySelect.addEventListener('change', () => this.filterCards());
      }

      this.filterCards();
      this.observeMaps();
    }

    observeMaps() {
      if (this.mapContainers.length === 0) {
        return;
      }

      if (!('IntersectionObserver' in window)) {
        this.mapContainers.forEach((container) => gsBranchesInitMap(container));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              gsBranchesInitMap(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '200px' }
      );

      this.mapContainers.forEach((container) => observer.observe(container));
    }

    handleGovernorateChange() {
      const governorate = this.governorateSelect.value;
      const cities = this.cityMap[governorate || '__all__'] || [];

      this.citySelect.innerHTML = '';

      const allOption = document.createElement('option');
      allOption.value = '';
      allOption.textContent = this.allCitiesLabel;
      this.citySelect.appendChild(allOption);

      cities.forEach((city) => {
        const option = document.createElement('option');
        option.value = city;
        option.textContent = city;
        this.citySelect.appendChild(option);
      });

      this.citySelect.value = '';
      this.filterCards();
    }

    filterCards() {
      const governorate = this.governorateSelect ? this.governorateSelect.value : '';
      const city = this.citySelect ? this.citySelect.value : '';
      let visibleCount = 0;

      this.cards.forEach((card) => {
        const matchesGovernorate = !governorate || card.dataset.governorate === governorate;
        const matchesCity = !city || card.dataset.city === city;
        const isVisible = matchesGovernorate && matchesCity;

        card.hidden = !isVisible;

        if (isVisible) {
          visibleCount += 1;
        }
      });

      if (this.countEl) {
        this.countEl.textContent = visibleCount;
      }

      if (this.emptyState) {
        this.emptyState.hidden = visibleCount !== 0;
      }
    }
  }

  customElements.define('gs-branches-locator', GsBranchesLocator);
}
